import { alignmentRecordDetailsSchema } from '../alignment-record/store/alignment-record-schema';

import type { HttpFetcherError } from '../../../shared/source/http-fetcher/http-fetcher';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type { AlignmentRecordDetails } from '../alignment-record/store/alignment-record-schema';
import type Result from 'true-myth/result';

export type FetchAlignmentRecordPayload = {
    readonly alignmentRecordId: string;
    readonly employeeId: string;
};

export type FetchAlignmentRecord = (
    payload: FetchAlignmentRecordPayload,
) => Promise<Result<AlignmentRecordDetails, HttpFetcherError>>;

export const createFetchAlignmentRecord = (
    validatingHttpFetcher: ValidatingHttpFetcherWithBaseUrl,
): FetchAlignmentRecord => {
    const fetchAlignmentRecord: FetchAlignmentRecord = async ({ alignmentRecordId, employeeId }) => {
        return validatingHttpFetcher.get(alignmentRecordDetailsSchema, {
            pathname: `/users/${employeeId}/alignment-records/${alignmentRecordId}`,
        });
    };

    return fetchAlignmentRecord;
};
